export default "__VITE_ASSET__DsmXIdn5__"